// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementUserMatcherResult = objectOf({
  filters: arrayOf(string),
  segments: arrayOf(string),
  apps: arrayOf(string),
  text: string,
});
